/** @jsxImportSource theme-ui */
import { ThemeUIStyleObject } from 'theme-ui';

export const dashboardHeaderStyles: Record<string, ThemeUIStyleObject> = {
  // Custom header container - complex layout not available via component props
  headerContainer: {
    bg: 'background',
    borderBottom: '1px solid',
    borderColor: 'neutral/300',
    px: '24px',
    py: 0,
    height: '80px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  // Custom left section layout - complex flex layout
  leftSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '2rem',
  },

  // Custom logo styling - specific styling not available via Text props
  logo: {
    color: 'primary',
    cursor: 'pointer',
    m: 0,
    fontSize: '24px',
    fontWeight: 'semibold',
  },

  // Custom filters section layout
  filtersSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  },

  // Custom selects container
  selectsContainer: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
  },

  // Custom results text styling - specific positioning and styling
  resultsText: {
    ml: 4,
    color: 'text.secondary',
    fontSize: '12px',
  },

  // Custom right section layout
  rightSection: {
    display: 'flex',
    alignItems: 'center',
  },
};
